import {
  AfterViewInit,
  Component,
  inject,
  PLATFORM_ID,
  ViewContainerRef,
} from "@angular/core";
import { RouterOutlet } from "@angular/router";
import {
  DrawerService,
  ModalService,
  ToastContainerComponent,
} from "@corp-ais/omniark-ui";
import { Layout } from "./layouts/layout";
import { isPlatformBrowser } from "@angular/common";
import { AuthService } from "./core";
import { hasSessionCookie } from "./shared/utils/token-encoding.utils";

@Component({
  selector: "app-root",
  imports: [RouterOutlet, Layout, ToastContainerComponent],
  templateUrl: "./app.html",
  styleUrl: "./app.scss",
})
export class App implements AfterViewInit {
  private readonly modalService = inject(ModalService);
  private readonly drawerService = inject(DrawerService);
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly authService = inject(AuthService);

  constructor() {
    // No session in this browser: straight to the login. (The token cookies
    // are HttpOnly; the session marker beside them is what script can see.)
    if (
      isPlatformBrowser(this.platformId) &&
      !hasSessionCookie(document.cookie)
    ) {
      this.authService.login(window.location.pathname + window.location.search);
    }
  }

  ngAfterViewInit() {
    this.modalService.setRootViewContainerRef(this.viewContainerRef);
    this.drawerService.setRootViewContainerRef(this.viewContainerRef);
  }
}
